const APIURL = "https://sonapi.nantech.az/api/Products";

export const getAllProducts = async (page = 0, take = 10) => {
  try {
    const response = await fetch(`${APIURL}/${page}/${take}`,{
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
      }
    });
    if (!response.ok) {
      throw new Error("Failed to fetch products");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching products:", error);
    return null;
  }
};

export const getProductById = async (id) => {
  try {
    const response = await fetch(`${APIURL}/${id}`,{
    
    
    });
    if (!response.ok) {
      throw new Error("Failed to fetch product");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching product:", error);
    return null;
  }
};

export const createProduct = async (productDto) => {
  try {
    const formData = new FormData();
    for (const key in productDto) {
      formData.append(key, productDto[key]);
    }

    const response = await fetch(APIURL, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to create product");
    }
    return { success: true };
  } catch (error) {
    console.error("Error creating product:", error);
    return { success: false, error: error.message };
  }
};

export const updateProduct = async (id, productDto) => {
  try {
    const formData = new FormData();
    for (const key in productDto) {
      formData.append(key, productDto[key]);
    }

    const response = await fetch(`${APIURL}/${id}`, {
      method: "PUT",
      body: formData,
    });

    if (!response.ok) {
      throw new Error("Failed to update product");
    }
    return { success: true };
  } catch (error) {
    console.error("Error updating product:", error);
    return { success: false, error: error.message };
  }
};

export const deleteProduct = async (id) => {
  try {
    const response = await fetch(`${APIURL}/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete product");
    }
    return { success: true };
  } catch (error) {
    console.error("Error deleting product:", error);
    return { success: false, error: error.message };
  }
};
